import { connect } from 'react-redux';
import { markPaymentReceived } from '@redux/modules/transactions';
import { showModal } from '@redux/modules/ui/modal';
import ViewItemExpanded from './ViewItemExpanded';

export default connect(null, {
  markPaymentReceived,
  showModal,
})(ViewItemExpanded);
